<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 19:14:39
 * @LastEditors: lwq
 * @LastEditTime: 2021-03-05 10:57:57
 * @FilePath: \web_admin\src\views\data-stored-procedure\modules\index.vue
-->
<template>
  <v-card>
    <v-card-text style="box-sizing: border-box">
      <v-row>
        <v-col cols="12" sm="6">
          <mrc_ess_input
            :label="$t('label_Stored_procedure_name') + '*'"
            :readonly="true"
            :background-color="disabled ? '' : '#f5f5f5'"
            :disabled="true"
            :placeholder="$t('label_runSqlGetStoredName')"
            v-model="params.procedure_name"
          ></mrc_ess_input>
        </v-col>
        <!-- judegNational('procedure_name') -->
        <!-- <v-col :cols="isHideAdmin ? 12 : 6"> -->
        <v-col cols="12" sm="6">
          <mrc_ess_multiText
            :label="$t('label_describe')"
            style="width:100%"
            :error-messages="
              $errors('params', 'procedure_description', nocharacter)
            "
            v-model="params.procedure_description"
            :isNational="judegNational('procedure_description')"
            :readonly="disabled"
          ></mrc_ess_multiText>
        </v-col>

        <v-col cols="12" v-if="isHideAdmin">
          <mrc_ess_prompt
            :errMsg="$errors('params', 'org_level_uuid', requiredRule)"
            :label="$t('label_The_company') + '*'"
            :disabled="companyCanSelect"
            :obj="companyObj"
            v-model="params.org_level_uuid"
          >
          </mrc_ess_prompt>
        </v-col>

        <v-col
          cols="12"
          class="d-flex flex-column"
          style="align-items: flex-end"
        >
          <v-sheet width="100%">
            SQL*
            <prism-editor
              :value="params.procedure_sql"
              :readonly="disabled"
              @change="sqlChangeHandler"
            ></prism-editor>
          </v-sheet>
          <!-- <v-textarea :background-color="disabled ? '' : '#f5f5f5'"
                      :value="params.procedure_sql"
                      auto-grow
                      style="width: 100%"
                      @change="sqlChangeHandler"
                      :readonly="disabled"
                      :placeholder="disabled ? ' ' : 'SQL'"
                      label="SQL*"></v-textarea> -->
          <v-btn
            v-if="sqlChange"
            rounded
            color="grey darken-2"
            depressed
            class="text-capitalize white--text mt-3"
            :loading="ExecuteLoading"
            @click="Execute"
            >{{ $t("label_Executed_immediately") }}</v-btn
          >
        </v-col>
        <v-col cols="12">
          <v-card
            v-if="sqlResult"
            style="min-height:200px;
                border: 1px solid #ededed;
                border-radius: 10px; "
          >
            <v-card-text>
              <p class="text-h5">{{ $t("label_errorLog") }}:</p>
              <p style="text-indent:2em">
                {{ sqlResult }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn
      @success="success"
      v-if="!disabled"
      :loading="loading"
      @cancel="cancel"
    ></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import { delProcedure, runSql } from "@/service/api/dataStoredProcedure"

import PrismEditor from "@/components/PrismEditor.vue"
export default {
  components: { PrismEditor },
  props: {
    paramsProps: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // disabled: false,
      ExecuteLoading: false,
      params: {
        procedure_name: "",
        procedure_description: "",
        procedure_sql: "",
        para_name: "",
        para_desc: "",
        org_level_uuid: "",
      },
      sqlResult: "",
      sqlChange: false,
      companyCanChange: false,
    }
  },
  validations: {
    params: {
      procedure_name: {
        required,
      },
      procedure_description: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      org_level_uuid: {
        required(val) {
          if (!this.isHideAdmin) {
            return true
          } else {
            if (val) {
              return true
            }
            return false
          }
        },
      },
    },
  },
  computed: {
    companyObj() {
      return {
        prompt_name: "org_levels_manager_filter_company_company",
        user_id: this.$store.state.userData.user_id,
        org_level_code: this.$store.state.currentCompanyObj.org_level_code,
      }
    },
    isHideAdmin() {
      return this.$store.state.userData.userType == 3
    },
    companyCanSelect() {
      return !this.companyCanChange || this.disabled
    },
  },
  created() {},
  watch: {
    paramsProps: {
      handler(val) {
        this.params = val
      },
      deep: true,
    },
    // 'params.procedure_sql' (val, oldVal) {
    //   if (oldVal!= val && val) {
    //     this.sqlChange = true
    //   }
    // }
  },
  async created() {
    await this.national("mrbase_sys_datamodel_procedure")
    if (this.paramsProps) {
      this.params = this.paramsProps
      this.sqlChange = false
      this.companyCanChange = false
    } else {
      this.companyCanChange = true
    }
  },

  methods: {
    sqlChangeHandler(val) {
      if (val == this.params.procedure_sql) {
        this.sqlChange = false
      } else {
        this.params.procedure_sql = val
        this.sqlChange = true
        this.companyCanChange = true
        // await this.Execute()
      }
    },
    cancel() {
      if (this.$store.state.uuid) {
        this.$emit("changeReadonly")
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then(() => {
            this.$router.go(-1)
          })
          .catch(() => {})
      }
    },
    success() {
      if (this.params.procedure_sql) {
        if (this.sqlChange) {
          let tips = this.$t("message_sql_statement_execution_error")
          if (this.sqlResult) {
            tips = this.$t("message_sql_statement_execution_error")
          } else {
            tips = this.$t("message_sql_statement_has_been_changed")
          }
          this.$myConfirm({ content: tips })
            .catch(() => {})
            .then(() => {})
          return
        }
      } else {
        this.$myConfirm({
          content: this.$t("message_please_enter_the_sql_statement"),
        })
          .then(() => {})
          .catch(() => {})
        return
      }

      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.$emit("success", this.params)
    },
    async Execute() {
      if (this.params.procedure_sql) {
        this.ExecuteLoading = true
        try {
          // 隐藏管理员运行sql的时候要判断有没有选择公司
          if (this.isHideAdmin && !this.params.org_level_uuid) {
            this.$myConfirm({
              content: this.$t("message_pleaseSelectOneCompany"),
            })
              .then((res) => {})
              .catch((err) => {})
            this.ExecuteLoading = false
            return
          }
          const res = await runSql({
            procedure_sql: this.params.procedure_sql,
            uuid: this.$store.state.uuid,
            org_level_uuid: this.params.org_level_uuid,
          })
          if (res.code == 200) {
            this.params.procedure_name = res.data.procedure_name
            if (this.isHideAdmin) {
              this.params.procedure_sql = res.data.procedure_sql
              this.companyCanChange = false
            }
            this.sqlResult = ""
            this.sqlChange = false
          } else {
            this.sqlResult = res.msg
          }
          this.ExecuteLoading = false
        } catch (err) {
          this.ExecuteLoading = false
        }
      } else {
        this.$myConfirm({
          content: this.$t("message_please_enter_the_sql_statement"),
        })
          .then(() => {})
          .catch(() => {})
      }
    },
  },
}
</script>

<style scoped></style>
